import { Suggestion, SubSector } from '@/types';

const subSectors: SubSector[] = [
  'multi-unit-dwellings',
  'single-dwellings',
  'commercial',
  'retail',
  'health',
  'education',
  'manufacturing',
  'agriculture',
  'forestry',
  'air-travel',
  'rail-freight',
  'marine-freight',
];

const suggestionsByCategory: any = {
  development: [],
  energy: [
    {
      name: 'Residential building efficiency',
      intervention: {
        name: 'Residential building efficiency',
        type: 'building-efficiency',
        description:
          'Reduction in energy use per dwelling based on national plan.',
        tag: 'current',
        sectors: ['single-dwellings', 'multi-unit-dwellings'],
        reductions: {
          stops: [
            { year: 2035, value: 5 },
            { year: 2050, value: 9 },
          ],
        },
      },
    },
    {
      name: 'Commercial & retail building efficiency',
      intervention: {
        name: 'Commercial & retail building efficiency',
        type: 'building-efficiency',
        description:
          'Reduction in energy use per employee based on national plan.',
        sectors: ['commercial', 'retail'],
        tag: 'current',
        reductions: {
          stops: [
            { year: 2035, value: 12 },
            { year: 2050, value: 21 },
          ],
        },
      },
    },
    {
      name: 'Grid decarbonisation (NZ)',
      intervention: {
        name: 'Grid decarbonisation (NZ)',
        type: 'grid-decarbonisation',
        description: 'Grid decarbonisation assumptions.',
        tag: 'current',
        factors: {
          stops: [
            { year: 2025, value: 0.040071 },
            { year: 2026, value: 0.042985 },
            { year: 2027, value: 0.045759 },
            { year: 2028, value: 0.04854 },
            { year: 2029, value: 0.051209 },
            { year: 2030, value: 0.053615 },
            { year: 2031, value: 0.056211 },
            { year: 2032, value: 0.055792 },
            { year: 2033, value: 0.055225 },
            { year: 2034, value: 0.05513 },
            { year: 2035, value: 0.054829 },
            { year: 2036, value: 0.054425 },
            { year: 2037, value: 0.054102 },
            { year: 2038, value: 0.053844 },
            { year: 2039, value: 0.052771 },
            { year: 2040, value: 0.051716 },
            { year: 2041, value: 0.050896 },
            { year: 2042, value: 0.046651 },
            { year: 2043, value: 0.047343 },
            { year: 2044, value: 0.047947 },
            { year: 2045, value: 0.047843 },
            { year: 2046, value: 0.047362 },
            { year: 2047, value: 0.046647 },
            { year: 2048, value: 0.045971 },
            { year: 2049, value: 0.045298 },
            { year: 2050, value: 0.042134 },
          ],
        },
      },
    },
    {
      name: 'Building electrification',
      intervention: {
        name: 'Building electrification',
        type: 'building-electrification',
        description:
          // eslint-disable-next-line max-len
          'Gas and LPG use reduced by % and reduced gas and LPG consumption converted to electricity using efficiency (different for each sector)',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'New building standards',
      intervention: {
        name: 'New building standards ',
        type: 'new-building-standards',
        description: 'Improved sustainability standards in new buildings',
        tag: 'current',
        sectors: subSectors,

        reductions: {
          stops: [{ year: 2025, value: 10.8 }],
        },
      },
    },
  ],
  transport: [
    {
      name: 'Mode shift to public transport',
      intervention: {
        name: 'Mode shift to public transport',
        description: '',
        tag: 'current',
        type: 'mode-shift-to-public-transport',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Mode shift to active transport',
      intervention: {
        type: 'mode-shift-to-active-transport',
        name: 'Mode shift to active transport',
        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Electric vehicle takeup',
      intervention: {
        type: 'electric-vehicle-takeup',
        name: 'Electric vehicle takeup',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Road to rail freight mode shift',
      intervention: {
        type: 'road-to-rail-freight-mode-shift',
        name: 'Road to rail freight mode shift',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Rail freight efficiency',
      intervention: {
        type: 'rail-freight-efficiency',
        name: 'Rail freight efficiency',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Air transport efficiency',
      intervention: {
        type: 'air-transport-efficiency',
        name: 'Air transport efficiency',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
  ],
  waste: [
    {
      name: 'Waste reduction',
      intervention: {
        type: 'waste-reduction',
        name: 'Waste reduction',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Diversion from landfill',
      intervention: {
        type: 'waste-diversion-from-landfill',
        name: 'Diversion from landfill',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Waste treatment',
      intervention: {
        type: 'waste-treatment',
        name: 'Waste treatment',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Wastewater treatment',
      intervention: {
        type: 'wastewater-treatment',
        name: 'Wastewater treatment',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
  ],
  ippu: [
    {
      name: 'Industrial-processed reduction',
      intervention: {
        type: 'industrial-processes',
        name: 'Industrial-processed reduction',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Product-use reduction',
      intervention: {
        type: 'product-use',
        name: 'Product-use reduction',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
  ],
  agriculture: [
    {
      name: 'Livestock reduction',
      intervention: {
        type: 'livestock',
        name: 'Livestock reduction',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
    {
      name: 'Horticulture reduction',
      intervention: {
        type: 'horticulture',
        name: 'Horticulture reduction',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
  ],
  forestry: [
    {
      name: 'Exotic forest change',
      intervention: {
        type: 'exotic-forest-change',
        name: 'Exotic forest change',

        description: '',
        tag: 'current',
        sectors: subSectors,
        reductions: {
          stops: [
            { year: 2035, value: 0 },
            { year: 2050, value: 0 },
          ],
        },
      },
    },
  ],
};

const suggestionsFlat: Suggestion[] = Object.entries(
  suggestionsByCategory,
).flatMap(([area, vs]: any) =>
  vs.map(
    (v: any) =>
      ({
        area,
        key: 'fixed',
        link: '',
        ...v.intervention,
      }) as Suggestion,
  ),
);

export { suggestionsByCategory, suggestionsFlat };
